module.exports = __webpack_public_path__ + "assets/img/android_success_icon.e01a55cd.svg";